import React from 'react';
import Title from '../../../../../@casino/ui/title';
import TableCasino from '../../../../../@casino/ui/table';
import { useDispatch, useSelector } from 'react-redux';
import {setGetListAdmin} from '../../store/thunk/setGetListAdmin';

const AdminList = () => {
    const dispatch = useDispatch();

  
    React.useEffect(() => {
        dispatch(setGetListAdmin());
    }, [])
    const list_admin = useSelector((state) => state.admin.list);

    const columns = [
        { id: 'id', label: 'ID'},
        { id: 'login', label: 'Логин'},
    ];
  
    const rows = list_admin.map((item) => {
        return {
            id: item.id,
            login: item.login
        }
    })

    return (
        <div style={{padding: 20, paddingTop: 0}}>
            <Title label="Администраторы" />
            <div style={{
                padding: 20, 
                background: '#1b2039', 
                borderRadius: 8, 
            }}>
                <TableCasino
                    route="/security/view/admin/"
                    width={300}
                    columns={columns}
                    rows={rows} 
                />
            </div>
        </div>
    )
}

export default AdminList;